import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Grid, Typography } from '@mui/material';
import Modal from 'components/Modal';

import { IStudentWorkingOffLessonModel } from '@common/models/StudentPrograms/StudentWorkingOffLesson';

import CourseInfoText from '../../CourseInfoText';
import ProgramSectionCourseInfoWorkingOffLessonItem from './LessonItem';

interface PropsType {
	working_off_lessons: IStudentWorkingOffLessonModel[];
}

function ProgramSectionCourseInfoWorkingOffLessons({ working_off_lessons }: PropsType) {
	const { t } = useTranslation();

	const [isModalOpen, setIsModalOpen] = useState(false);

	const handleOpen = () => {
		setIsModalOpen(true);
	};

	const handleClose = () => {
		setIsModalOpen(false);
	};

	const showWorkingOffLessons = working_off_lessons.length > 0;

	return (
		<>
			<CourseInfoText label={t('program.workingOff')} value={working_off_lessons.length}>
				{showWorkingOffLessons && (
					<Typography
						variant="body3"
						color="primary"
						sx={{ textDecoration: 'underline', cursor: 'pointer' }}
						onClick={handleOpen}
					>
						{t('program.review')}
					</Typography>
				)}
			</CourseInfoText>
			{showWorkingOffLessons && (
				<Modal
					title={t('program.workingOff')}
					open={isModalOpen}
					onClose={handleClose}
					PaperProps={{ sx: { maxWidth: 'min(850px,95%)' } }}
				>
					<Grid container direction="column" gap="8px">
						{working_off_lessons.map((lesson) => (
							<ProgramSectionCourseInfoWorkingOffLessonItem
								key={lesson.lesson_id}
								working_off_lesson={lesson}
							/>
						))}
					</Grid>
				</Modal>
			)}
		</>
	);
}

export default ProgramSectionCourseInfoWorkingOffLessons;
